//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('acVatCodeData', {
//        templateUrl: 'views/components/views/acVatCodeData/acVatCodeData.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'acVatCodeDataService', function ($stateParams, stateService, translateService, modalService, acVatCodeDataService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let acVatCodeKeyno = $stateParams.acvatcode_keyno;
//            let acVatCodeDataKeyno = $stateParams.acvatcodedata_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                vatReportGroupsButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.vatreportgroup_keyno = '0' }
//                ],
//                vatTaxLevelsButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.vattaxlevel_keyno = '0' }
//                ],
//                edit: {},
//                selectListVatReportGroups: [],
//                selectListVatTaxLevels: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await acVatCodeDataService.getEdit({
//                    acvatcode_keyno: acVatCodeKeyno,
//                    acvatcodedata_keyno: acVatCodeDataKeyno
//                }))[0];
//            }

//            async function loadVatReportGroups() {
//                vm.model.selectListVatReportGroups = await acVatCodeDataService.listVatReportGroups();
//            }

//            async function loadVatTaxLevels() {
//                vm.model.selectListVatTaxLevels = await acVatCodeDataService.listVatTaxLevels();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                acVatCodeDataService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//                loadVatReportGroups();
//                loadVatTaxLevels();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
